import { SupplierFormValues } from '../containers';

type ValidationErrors = Record<string, string[] | undefined>;

export type SupplierValidationOptions = {
  /** Regional Admins must give a Supplier at least one Region (SuperAdmin: optional). */
  requireRegion?: boolean;
};

export const validateSupplier = async (
  values: SupplierFormValues,
  options: SupplierValidationOptions = {},
): Promise<ValidationErrors> => {
  const errors: ValidationErrors = {};

  if (options.requireRegion && !(values.selectedRegions ?? []).length) {
    errors.selectedRegions = ['The Region is required'];
  }

  if (!values.name) {
    errors.name = ['The name is required'];
  }
  if (!values.externalId) {
    errors.externalId = ['The External Id is required'];
  }
  if (!values.description) {
    errors.description = ['The Description is required'];
  }
  if (!values.email) {
    errors.email = ['The Email is required'];
  }
  if (!values.phone) {
    errors.phone = ['The Phone is required'];
  }
  if (!values.contactInfo) {
    errors.contactInfo = ['The Contact Info is required'];
  }

  return errors;
};
